import { observable, computed, action, autorun } from 'mobx';

import { App, ArrayApp, AppRegistry, ModelRegistry } from 'core';
import { AppFactory } from 'core/app';

import { PermissionedModel } from 'apps/permissions/app';

class HTMLNotificationModel extends PermissionedModel {
  static registryName = 'HTMLNotificationModel';
  @observable html = '';
  @observable url = '';
  @observable level = '';
}
ModelRegistry.add(HTMLNotificationModel);

class HTMLNotificationApp extends App {
  static registryName = 'HTMLNotificationApp';
  //
}
AppRegistry.add(HTMLNotificationApp);

export class NotificationModel extends PermissionedModel {
  static registryName = 'NotificationModel';
  static ModelProps = {
    author: 'ProfileModel',
  };

  @observable author;
  @observable type = '';
  @observable target = null;
  @observable when = '';
  @observable read = false;

  @observable targetModel = null;

  constructor() {
    super();

    autorun(() => {
      if (!this.target?.__typename) {
        this.targetModel = null;
        return;
      }
      const typename =
        this.target.__typename === 'GroupInvite'
          ? 'Invite'
          : this.target.__typename;
      const ModelClass = ModelRegistry.get(`${typename}Model`);
      this.targetModel = ModelClass ? ModelClass.Load(this.target) : null;
    });
  }

  @computed get targetDisplayType() {
    return this.target.__typename;
  }
}
ModelRegistry.add(NotificationModel);

export class NotificationApp extends App {
  static registryName = 'NotificationApp';
  static AppProps = {
    author: 'ProfileApp',
  };

  static Model = NotificationModel;

  @observable targetApp = null;

  constructor(...args) {
    super(...args);

    autorun(() => {
      if (!(this.upstream?.targetModel && this.upstream?.target.__typename)) {
        this.targetApp = null;
        return;
      }
      const typename =
        this.upstream.target.__typename === 'GroupInvite'
          ? 'Invite'
          : this.upstream.target.__typename;
      const AppClass = AppRegistry.get(`${typename}App`);
      if (!AppClass) {
        this.targetApp = null;
        return;
      }
      const appFactory = AppFactory(this, AppClass);
      this.targetApp = appFactory(this.upstream.targetModel).get();
    });
  }

  @action SetRead = read => {
    this.read = read;
  };
}
AppRegistry.add(NotificationApp);

export class NotificationsApp extends ArrayApp {
  static registryName = 'NotificationsApp';
  static ElementApp = NotificationApp;
}
